export default function (url) {
	return url ? url.replace(/(http(s)?:)?\/\/[^/]+\/(.*)/i, '/$3') : url;
}
